let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ZHFL")).then(() => parcelRequire('2FR9O'));